import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserService } from './services/user.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { GoogleAuthConfig } from './auth-config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'tsphere ';
  
  topbarTheme = 'red';

  menuTheme = 'light';

  layoutMode = 'light';

  menuMode = 'static';

  isRTL = false;

  inputStyle = 'outlined';

  ripple!: boolean;
  private readonly _destroying$ = new Subject<void>();
  dataSource: any = [];




  constructor(private router: Router, private oauthService: OAuthService, private primengConfig: PrimeNGConfig, private userService: UserService) {

    this.oauthService.configure(GoogleAuthConfig);
    this.oauthService.loadDiscoveryDocument("https://tspherecomputing.b2clogin.com/4b509e6e-e5f7-4b6b-b3ad-ea1dcd7847f2/v2.0/.well-known/openid-configuration").then(res => {
      this.oauthService.tryLogin();
      if (!this.oauthService.hasValidIdToken() || !this.oauthService.hasValidAccessToken()) {
        this.oauthService.initImplicitFlow();
        return false;
      } else {
        return true;
      }
    })
    //this.oauthService.setupAutomaticSilentRefresh();

    // Automatically load user profile
    this.oauthService.events
      .pipe(filter((e) => e.type === 'token_received'))
      .subscribe((_) => this.oauthService.loadUserProfile());
  }

  get userName(): string {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['given_name'];
  }
  get allClaims(): string {
    const claims = this.oauthService.getIdentityClaims();
    let retVal = "";
    for (const [key, value] of Object.entries(claims)) {
      retVal = retVal + key + " " + value + "\n";
    }
    return retVal;
  }
  get idToken(): string {
    return this.oauthService.getIdToken();
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

  refresh() {
    this.oauthService.refreshToken();
  }
  ngOnInit() {
    this.primengConfig.ripple = true;

  }

  getClaims(claims: any) {
    this.dataSource = [
      { id: 1, claim: "Display Name", value: claims ? claims['name'] : null },
      { id: 2, claim: "User Principal Name (UPN)", value: claims ? claims['preferred_username'] : null },
      { id: 2, claim: "OID", value: claims ? claims['oid'] : null }
    ];
  }
}
